module.exports = __webpack_public_path__ + "static/img/pingwei.a4d022b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/pingwei.png
// module id = 1YBy
// module chunks = 6